import { useEffect } from "react";
import {
  getPreviewTransformForMeshUuid,
  getPreviewUpdateEventName,
} from "../../mesh-editor/previewState";
import { safeTraverse } from "../scene/sceneObjectLookups";

function toNum(value, fallback) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function useMeshEditorPreviewTransforms({ sceneRef }) {
  useEffect(() => {
    const applyMeshEditorPreviewTransforms = () => {
      if (!sceneRef.current) return;
      safeTraverse(sceneRef.current, (obj) => {
        if (!obj?.userData || obj.userData.transformLayer !== "meshEditor") return;
        const meshUuid = obj.userData.meshName;
        const transform = getPreviewTransformForMeshUuid(meshUuid);
        if (!transform) {
          obj.position.set(0, 0, 0);
          obj.quaternion.set(0, 0, 0, 1);
          return;
        }
        obj.position.set(
          toNum(transform.pos?.[0], 0),
          toNum(transform.pos?.[1], 0),
          toNum(transform.pos?.[2], 0)
        );
        const q = Array.isArray(transform.quat) ? transform.quat : [1, 0, 0, 0];
        obj.quaternion.set(toNum(q[1], 0), toNum(q[2], 0), toNum(q[3], 0), toNum(q[0], 1));
      });
    };

    const eventName = getPreviewUpdateEventName();
    window.addEventListener(eventName, applyMeshEditorPreviewTransforms);
    applyMeshEditorPreviewTransforms();
    return () => {
      window.removeEventListener(eventName, applyMeshEditorPreviewTransforms);
    };
  }, [sceneRef]);
}
